/**
 *
 * Button
 *
 */

import styled from 'styled-components';
import buttonStyles from './buttonStyles';

const Button = styled.button`
  cursor: pointer;
  padding: 16px 30px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 14px;
  text-align: center;
  
  &:focus {
    outline: none;
  }

  ${({ className }) => className ? '' : buttonStyles}
`;

export default Button;
